import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, LogIn } from "lucide-react";
import { useAuth } from "@/portal/AuthContext";

const LOGO_IMG = "/img/n148kmw9_image.webp";

const LoginPage = () => {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user) {
      navigate((user.role === "admin" || user.role === "assistant" || user.role === "accountant") ? "/admin" : user.role === "partner" ? "/flotila" : user.role === "worker" ? "/prace" : "/klient", { replace: true });
    }
  }, [user, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const u = await login(email, password);
      navigate((u.role === "admin" || u.role === "assistant" || u.role === "accountant") ? "/admin" : u.role === "partner" ? "/flotila" : u.role === "worker" ? "/prace" : "/klient", { replace: true });
    } catch (err) {
      setError(err.message || "Přihlášení se nezdařilo");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8">
          <img src={LOGO_IMG} alt="EffectDeal" className="w-10 h-10 object-contain" />
          <span className="font-['Cabinet_Grotesk'] font-bold text-xl tracking-wide">EFFECTDEAL</span>
        </Link>

        <div className="glass p-6 sm:p-8 rounded-2xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-indigo-500/20 flex items-center justify-center">
              <Lock className="w-5 h-5 text-indigo-400" />
            </div>
            <h1 className="font-['Cabinet_Grotesk'] text-xl sm:text-2xl font-bold">Přihlášení</h1>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="block text-xs text-zinc-400 mb-1.5">E-mail</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-dark text-base"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="block text-xs text-zinc-400 mb-1.5">Heslo</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-dark text-base"
                data-testid="login-password"
              />
            </div>

            {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}

            <button
              type="submit"
              disabled={submitting}
              className="btn-accent w-full inline-flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="login-submit"
            >
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
              Přihlásit se
            </button>
          </form>
        </div>

        <p className="text-center text-zinc-600 text-xs mt-6">
          © 2024 EffectDeal · Klientská zóna
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
